import { BASE_URL } from "helpers/api_helper";
import { io } from "socket.io-client";

const token = localStorage.getItem("auth_token");

export const socket = io(BASE_URL, {
    auth: { token },
    autoConnect: true,
    reconnection: true,
    reconnectionAttempts: Infinity,
    reconnectionDelay: 1000,
    reconnectionDelayMax: 5000,
});

socket.on("connect", () => {
    console.log("✅ Socket connecté, id=", socket.id);
});
socket.io.on("ping", () => {
    console.log("🏓 ping");
});
socket.on("connect_error", (err) => {
    console.error("❌ Erreur de connexion:", err.message);
});
socket.on("disconnect", (reason) => {
    console.warn("🚪 Déconnecté:", reason);
});
